import { createFileRoute } from '@tanstack/react-router';

import {
  AdminWorkspacesPage,
  workspacesSearchSchema,
} from '@/features/organization-admin';

export const Route = createFileRoute('/admin/workspaces')({
  // The search, the slice and the order live in the address (spec 191), as the
  // people list's do: the "no active owner" notice opens the page on its slice.
  // So do the tab, the open sheet and the activity's range (spec 195), so a link
  // opens the same view for another admin.
  validateSearch: workspacesSearchSchema,
  component: AdminWorkspacesRoute,
});

export function AdminWorkspacesRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <AdminWorkspacesPage
      view={{
        tab: search.tab ?? 'workspaces',
        q: search.q ?? '',
        show: search.show ?? 'all',
        sort: search.sort,
        visibility: search.visibility ?? 'any',
        workspace: search.workspace,
        from: search.from,
        to: search.to,
        logWorkspace: search.logWorkspace,
      }}
      onChange={(next, how) => {
        void navigate({
          search: (prev) => ({
            ...prev,
            ...('tab' in next
              ? { tab: next.tab === 'workspaces' ? undefined : next.tab }
              : {}),
            ...('q' in next ? { q: next.q || undefined } : {}),
            ...('show' in next
              ? { show: next.show === 'all' ? undefined : next.show }
              : {}),
            ...('sort' in next ? { sort: next.sort } : {}),
            ...('visibility' in next
              ? {
                  visibility:
                    next.visibility === 'any' ? undefined : next.visibility,
                }
              : {}),
            ...('workspace' in next ? { workspace: next.workspace } : {}),
            ...('from' in next ? { from: next.from } : {}),
            ...('to' in next ? { to: next.to } : {}),
            ...('logWorkspace' in next
              ? { logWorkspace: next.logWorkspace }
              : {}),
          }),
          // A tab or a sheet is a place, so Back returns from it; typing in the
          // search or turning a chip is not.
          replace: !how?.push,
        });
      }}
    />
  );
}
